/**
 * Незавершённый ЗАПУСК генерации песни: пользователь нажал «Создать песню»,
 * бэк ответил 402 (не хватает баланса) и он ушёл платить.
 *
 * Зачем отдельный маркер, хотя есть `pendingMelodySongId` в черновике формы:
 * черновик пишется общим persist-эффектом всякий раз, когда готов текст, т.е.
 * означает «у пользователя есть текст», а вовсе не «пользователь нажал Создать
 * и упёрся в пейвол». По черновику резюм был дырой: подготовил текст → не нажал
 * «Создать» → купил пакет песен впрок из «Баланса» → возврат запускал генерацию
 * и тратил только что купленный баланс без единого клика.
 *
 * Поэтому маркер ставится ТОЛЬКО в обработчике 402 (по образцу
 * `pendingClipAction` / `pendingReleaseOrder`) — он кодирует реальное намерение
 * «я упёрся в пейвол, оплачиваю ИМЕННО генерацию этого текста». Черновик формы
 * остаётся тем, чем и был, — восстановлением ввода.
 *
 * Живёт час, как соседние маркеры. Снимается, когда генерация реально
 * стартовала (см. страницы генерации).
 */
const STORAGE_KEY = "tvoy_podarok_pending_song_generation";
const MAX_AGE_MS = 60 * 60 * 1000;
export function savePendingSongGeneration(textId) {
    if (!(Number.isFinite(textId) && textId > 0))
        return;
    try {
        const payload = { textId, savedAt: Date.now() };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    }
    catch {
        /* private mode / quota */
    }
}
export function getPendingSongGeneration() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw)
            return null;
        const s = JSON.parse(raw);
        const textId = Number(s.textId);
        if (!(Number.isFinite(textId) && textId > 0))
            return null;
        const savedAt = Number(s.savedAt);
        if (Number.isFinite(savedAt) && Date.now() - savedAt > MAX_AGE_MS) {
            clearPendingSongGeneration();
            return null;
        }
        return {
            textId,
            savedAt: Number.isFinite(savedAt) ? savedAt : Date.now(),
        };
    }
    catch {
        return null;
    }
}
export function clearPendingSongGeneration() {
    try {
        localStorage.removeItem(STORAGE_KEY);
    }
    catch {
        /* no-op */
    }
}
